import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Page404 = () => {
  return (
    <section className="bg-background">
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div className="mx-auto max-w-screen-sm text-center">
          <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary">
            404
          </h1>
          <p className="mb-4 text-3xl tracking-tight font-bold text-foreground md:text-4xl">
            Something&#39;s missing.
          </p>
          <p className="mb-4 text-lg font-light text-muted-foreground">
            Sorry, we can&#39;t find that page. You&#39;ll find lots to explore
            on the home page.
          </p>
          <Button asChild>
            <Link to="/">Back to Homepage</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Page404;
